<template>
  <BModal
    title="Identificação do cliente"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Confirmar"
    cancel-title="Cancelar"
    v-model="mostrar"
    @show="carregar"
    @ok="retornaCliente"
    @cancel="cancel">
    <BForm
      @submit.prevent="retornaCliente"
      class="form">
      <InputSugestaoCliente
        ref="inputCliente"
        label="Cliente"
        name="inputCliente"
        class="input__cliente"
        v-model="cliente"
        v-validate="'required'"
        :errorsBag="errors"
        :limparSugestao="limparSugestao" />

      <BButton
        @click.prevent="abrirCadastroCliente"
        variant="outline-primary">
        Novo cliente
      </BButton>
    </BForm>
  </BModal>
</template>

<script>
import { BForm, BModal, BButton } from 'bootstrap-vue/es/components'
import InputSugestaoCliente from '../../components/input/sugestao/InputSugestaoCliente.vue'
import usuarioStorage from '../../local-storage/usuarioStorage'

export default {
  name: 'IdentificacaoCliente',
  components: {
    BForm,
    BModal,
    BButton,
    InputSugestaoCliente,
  },
  data() {
    return {
      resolve: null,
      mostrar: false,
      cliente: null,
      limparSugestao: true,
    }
  },
  methods: {
    carregar() {
      this.cliente = usuarioStorage.getCliente()
      this.limparSugestao = !this.cliente
      this.focarPrimeiroCampo()
    },
    pop() {
      this.mostrar = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    retornaCliente(event) {
      event.preventDefault()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.mostrar = false
          this.resolve(this.cliente)
        }
      })
    },
    cancel() {
      this.mostrar = false
      this.resolve(false)
    },
    focarPrimeiroCampo() {
      setTimeout(() => {
        this.$refs.inputCliente.focar()
      }, 1);
    },
    abrirCadastroCliente() {
      this.$router.push({ name: 'rota-clientes-cadastro' })
    },
  },
}

</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.input__cliente {
  width: 100%;
}

</style>
